module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution2_1-f2a4ce958863cf1654b1c80f1f565378.png";